import { PsicolotticoQuestResponseJSON } from '../types/psicolottico'
import {
  AmoreResponseJSON,
  CucinaResponseJSON,
  NomiNumeriResponseJSON,
  OroscopoResponseJSON,
  PsicolotticoResponseJSON
} from '../types/output-data'
import { CucinaRequestJSON } from '../types/input-data'
import { sortNumbersString } from './generic-utils'
import { ERROR_CAUSE, ERROR_MESSAGE } from '../types/enums'

/* Funzioni ausiliarie che deserializzano il contenuto di file JSON e riportano i dati utili */

// NOME
export const extractNomiResponseDataFromJSON = (
  jsonContent: NomiNumeriResponseJSON
): NomiNumeriResponseJSON => {
  const talismano = jsonContent?.talisman?.trim() ?? ''
  const giorno = jsonContent?.day?.trim() ?? ''
  const descrizione = jsonContent?.description?.trim() ?? ''
  const varianti = jsonContent?.alternatives?.trim() ?? ''

  const numeri = jsonContent?.numbers?.trim() ?? ''
  if (numeri === undefined || numeri.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgEmptyNumber, { cause: ERROR_CAUSE.EmptyNumber })
  }

  return {
    numbers: numeri,
    talisman: talismano,
    day: giorno,
    description: descrizione,
    alternatives: varianti
  }
}

// TEST-PSICOLOTTICO
export const extractPsicolotticoQuestionsAnswersFromJSON = (
  jsonContent: PsicolotticoQuestResponseJSON
): Record<string, string[]> => {
  const questions = jsonContent.Envelope.Body.getQuestPsicolotticoResponse.result.list
  const domandeRisposte: Record<string, string[]> = {}

  questions.forEach((question) => {
    domandeRisposte[question.domanda.trim()] = [
      question.rispostaA.trim(),
      question.rispostaB.trim(),
      question.rispostaC.trim()
    ]
  })

  return domandeRisposte
}

export const extractPsicolotticoResponseDataFromJSON = (
  jsonContent: PsicolotticoResponseJSON
): PsicolotticoResponseJSON => {
  const description = jsonContent?.description?.trim() ?? ''
  const profile = jsonContent.profile?.trim() ?? ''

  const randomNumbers = jsonContent?.randomNumbers?.sort(sortNumbersString) ?? []
  if (randomNumbers === undefined || randomNumbers.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgEmptyNumber)
  }

  return {
    description: description,
    randomNumbers: randomNumbers,
    profile: profile
  }
}

// AMORE
export const extractAmoreResponseDataFromJSON = (jsonContent: AmoreResponseJSON): string[] => {
  const numbers = jsonContent?.result?.sort(sortNumbersString) ?? []
  if (numbers === undefined || numbers.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgEmptyNumber)
  }

  return numbers
}

// CUCINA
export const extractCucinaStepOptionsFromJSON = (
  jsonContent: CucinaRequestJSON,
  step: number
): string[] => {
  let result
  switch (step) {
    case 1:
      result = jsonContent?.firstIngredient?.split(',') ?? []
      break
    case 2:
      result = jsonContent?.secondIngredient?.split(',') ?? []
      break
    case 3:
      result = jsonContent?.recipe ? [jsonContent.recipe] : []
      break
    default:
      console.error('Cannot retrieve options for step, ', step)
      throw new Error(ERROR_MESSAGE.msgRetry)
  }

  if (result === undefined || result.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgRetry)
  } else {
    return result
  }
}

export const extractCucinaResponseDataFromJSON = (
  jsonContent: CucinaResponseJSON
): CucinaResponseJSON => {
  const ingredients = jsonContent?.ingredients ?? []
  const wheel = jsonContent?.wheel?.trim() ?? ''
  const preparationSteps = jsonContent?.preparationSteps?.trim() ?? ''
  const recipe = jsonContent?.recipe?.trim() ?? ''

  const numbers = jsonContent?.numbers?.sort(sortNumbersString)
  if (numbers === undefined || numbers.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgEmptyNumber)
  }

  return {
    ingredients: ingredients,
    wheel: wheel,
    preparationSteps: preparationSteps,
    numbers: numbers,
    recipe: recipe
  }
}

export const extractOroscopoResponseDataFromJSON = (
  jsonContent: OroscopoResponseJSON
): OroscopoResponseJSON => {
  const description = jsonContent?.description?.trim() ?? ''

  const numbers = jsonContent?.numbers?.sort(sortNumbersString) ?? []
  if (numbers === undefined || numbers.length <= 0) {
    throw new Error(ERROR_MESSAGE.msgEmptyNumber)
  }

  return {
    numbers: numbers,
    description: description
  }
}
